<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <div class="relative z-10 flex flex-col justify-center items-start w-full text-left h-full">
      <!-- Title -->
      <h2 class="text-4xl md:text-5xl text-center mb-16">{{ t("Digitale Oplossingen") }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
        <!-- Column 1 -->
        <div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Modern Matchingsplatform") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Ons geavanceerde platform zorgt voor optimale personeelsplanning met real-time inzicht in de beschikbaarheid van zorgprofessionals, zodat u altijd de juiste mensen op de juiste plek heeft.") }}</p>
        </div>
        <!-- Column 2 -->
        <div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Dashboard") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Digitale urenbriefjes en goedkeuringsprocessen verminderen administratieve lasten aanzienlijk. Alle communicatie verloopt beveiligd tussen alle betrokken partijen") }}</p>
        </div>
        <!-- Column 3 -->
        <div>
          <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Naadloze Integratie") }}</h3>
          <p
            class="text-gray-700"
          >{{ t("Ons platform kan worden gekoppeld aan uw bestaande systemen voor optimale efficiëntie en minimale verstoring van uw werkprocessen.") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
